import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {HelpModule} from "../../components/help/help.module";
import {PruefungProtokollePage} from "./pruefung-protokolle";
import {NgPipesModule, PairsPipe} from "ngx-pipes";
import {ProtokollComponent, ReviewPopoverComponent} from "../../components/protokoll/protokoll";

@NgModule({
  declarations: [
    PruefungProtokollePage,
    ProtokollComponent,
    ReviewPopoverComponent
  ],
  entryComponents: [
    PruefungProtokollePage,
    ReviewPopoverComponent
  ],
  imports: [
    IonicPageModule.forChild(PruefungProtokollePage),
    HelpModule,
    NgPipesModule
  ],
  providers: [
    PairsPipe
  ]
})
export class PruefungProtokolleModule {}



// WEBPACK FOOTER //
// ./src/pages/pruefung-protokolle/pruefung-protokolle.module.ts